/** @jsx jsx */
import { jsx } from "theme-ui";

import { graphql } from "gatsby";
import { builder, BuilderComponent } from "@builder.io/react";
import "../blocks/registerBuilderComponents";
import PageHeader from "../blocks/page-header/page-header";
import PageFooter from "../blocks/page-footer/page-footer";
import React, { Fragment } from "react";
import { setPixelProperties } from '@builder.io/utils';
// Initialize the Builder SDK with your organization's API Key
// Find the API Key on: https://builder.io/account/settings
builder.init("83f2d95e39d4456aa87de5837f1ad558");

// Your template populates your Gatsby pages with your Builder page content.
function PageTemplate({ data }: { data: any }) {
  const models = data?.allBuilderModels;
  const page = models.onePage?.content;
  setPixelProperties(page, { alt: 'pixel tag from builder' })
  //console.log(page)
  return (
    <main>
      <PageHeader />
      <BuilderComponent name="page" content={page} />
      <PageFooter />
    </main>
  );
}

export function Head({ data, location }: { data: any; location: any }) {
  const models = data?.allBuilderModels;
  const page: {
    title: string;
    description: string;
    follow: string;
    image: string;
    index: true;
  } = models.onePage?.content.data;

  const defaultMeta: {
    defaultSeoImage: string;
    siteName: string;
    siteUrl: string;
  } = models.oneSiteSettings?.data;

  //console.log("location", location);

  const baseUrl = defaultMeta.siteUrl.endsWith("/")
    ? defaultMeta.siteUrl.slice(0, -1)
    : defaultMeta.siteUrl;
  const fullUrl = baseUrl + location.pathname === "/" ? "" : location.pathname;
const pageTitle =  `${page.title} - ${defaultMeta.siteName}`

  return (
    <Fragment>
      <html lang="en" />
      <title>
       {pageTitle}
      </title>
      <meta name="description" content={page.description} />
      <link rel="canonical" href={fullUrl} />
      <meta
        name="robots"
        content={`${page.follow ? "index" : "noindex"} ${
          page.follow ? "follow" : "nofollow"
        }`}
      ></meta>

      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:type" content={"page"} />
      {defaultMeta.siteName && (
        <meta property="og:site_name" content={defaultMeta.siteName} />
      )}
      {defaultMeta.defaultSeoImage && (
        <meta property="og:image" content={defaultMeta.defaultSeoImage} />
      )}
      {page.description && (
        <meta property="og:description" content={page.description} />
      )}
      <meta property="og:locale" content={"en_AU"} />

      <meta name="twitter:card" content="summary_large_image" />

      <meta name="twitter:title" content={pageTitle} />
      {defaultMeta.defaultSeoImage && (
        <meta name="twitter:image" content={defaultMeta.defaultSeoImage} />
      )}
    </Fragment>
  );
}

export default PageTemplate;

// pageQuery is a GraphQL query that
// fetches each page's content from Builder.
// Your content is rendered within the
// PageTemplate using BuilderComponent, provided by Builder's SDK.
export const pageQuery = graphql`
  query ($path: String!) {
    allBuilderModels {
      onePage(
        target: { urlPath: $path }
        options: { cachebust: true, includeRefs: true }
      ) {
        content
      }
      oneSiteSettings {
        data {
          defaultSeoImage
          siteName
          siteUrl
        }
      }
    }
  }
`;

